export const categories = [
  {
    id: 1,
    name: "独家精品",
    slug: "exclusive",
    description: "精选高品质独家内容，为您呈现最优质的精神食粮",
    icon: "ri-star-smile-line",
    articleCount: 128,
  },
  {
    id: 2,
    name: "高清资源",
    slug: "hd-resources",
    description: "全高清画质资源库，每一帧都是视觉盛宴",
    icon: "ri-4k-line",
    articleCount: 95,
  },
  {
    id: 3,
    name: "最新推荐",
    slug: "latest",
    description: "实时更新最新内容，不错过每一个精彩瞬间",
    icon: "ri-flashlight-line",
    articleCount: 203,
  },
  {
    id: 4,
    name: "经典回顾",
    slug: "classic",
    description: "历久弥新的经典之作，值得反复品味的永恒魅力",
    icon: "ri-vip-crown-line",
    articleCount: 76,
  },
  {
    id: 5,
    name: "深度解读",
    slug: "deep-dive",
    description: "专业视角深度剖析，带你走进内容背后的故事",
    icon: "ri-magic-line",
    articleCount: 54,
  },
  {
    id: 6,
    name: "热门排行",
    slug: "trending",
    description: "当下最受欢迎的热门内容，用户口碑实力推荐",
    icon: "ri-fire-line",
    articleCount: 167,
  },
];